
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Banks": () => {
return Promise.all(/*  | __federation_expose_Banks */ [__webpack_require__.e("558"), __webpack_require__.e("849"), __webpack_require__.e("655"), __webpack_require__.e("22")]).then(() => (() => (__webpack_require__(23))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };